export class AddNew {

    constructor(store) {
        this.store = store;
        this.caller = null;
    }

    render(caller) {
        this.caller = caller;
        const wrapper = document.createElement("div");
        wrapper.className="newform-avatars";
        let newfurnitureavatar = this.createAvatar('/assets/newfurniture.png' , 'Új bútor')
        wrapper.appendChild(newfurnitureavatar);
        let newuseravatar = this.createAvatar('/assets/newuser.png' , 'Új kolléga')
        wrapper.appendChild(newuseravatar);
        return wrapper
    }

    createAvatar(imageUrl, text) {
        const avatatrwrapper = document.createElement("div");
        avatatrwrapper.className="newform-avatar";
        const img=document.createElement("img");
        img.src=imageUrl;
        img.className="newform-avatarpic";
        img.id = text
        const label = document.createElement("div");
        label.textContent = text;
        label.className = this.store.config.isSmall ? "font-10 weight-600 color-50 justify-center" : "font-30 weight-600 color-50 justify-center";
        avatatrwrapper.appendChild(img);
        avatatrwrapper.appendChild(label);
        this.bindItemEvents(img);
        return avatatrwrapper
    }

    bindItemEvents(item) {
        item.addEventListener("click", e => {
            e.stopPropagation();
            this.store.modalController.callNewForm(item); 
        });
    }

    getData(form) {
        const result = {};
        Object.entries(this.data).forEach(([key, value]) => {
            const input = form.elements[key];
            result[key] = typeof value === "number" ? Number(input.value) : input.value;});
        return result;
    }

    

}